// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f68ad58c","239":"9b051923","455":"93085e42"}[chunkId] + ".chunk.js";
};